export interface FarmPricingInput {
  hourly_machine_cost_cents:  number;
  hours_estimated:            number;
  setup_fee_cents:            number;
  filament_grams:             number;
  filament_cost_per_kg_cents: number;
  filament_markup_pct:        number;
  delivery_km?:               number;
  delivery_fee_base_cents:    number;
  delivery_fee_per_km_cents:  number;
  modeling_fee_cents?:        number;
}

export interface FarmPricingResult {
  supplier_amount_cents: number;
  platform_fee_cents:    number;
  total_amount_cents:    number;
  breakdown: {
    filament_cents: number;
    machine_cents:  number;
    setup_cents:    number;
    delivery_cents: number;
    modeling_cents: number;
  };
}

const PLATFORM_FEE_PCT = 0.07; // 7%

export function calcFarmPricing(i: FarmPricingInput): FarmPricingResult {
  const filament_cents = Math.round(
    (i.filament_grams / 1000) * i.filament_cost_per_kg_cents * (1 + i.filament_markup_pct / 100)
  );
  const machine_cents = Math.round(i.hourly_machine_cost_cents * i.hours_estimated);
  const delivery_cents = i.delivery_km != null
    ? i.delivery_fee_base_cents + i.delivery_fee_per_km_cents * i.delivery_km
    : 0;
  const setup_cents = i.setup_fee_cents;
  const modeling_cents = i.modeling_fee_cents ?? 0;

  const supplier_amount_cents = filament_cents + machine_cents + setup_cents + delivery_cents + modeling_cents;
  const platform_fee_cents    = Math.round(supplier_amount_cents * PLATFORM_FEE_PCT);
  const total_amount_cents    = supplier_amount_cents + platform_fee_cents;

  return {
    supplier_amount_cents,
    platform_fee_cents,
    total_amount_cents,
    breakdown: { filament_cents, machine_cents, setup_cents, delivery_cents, modeling_cents },
  };
}
